 <template>
      <v-app v-cloak>

    <core-toolbar @home="home">
         <match-list v-if="Role('_admin,_reseller,lead')" @select="selectMatch" :listview="true" :index="index" :list="suppliers" :showUser="showUser"></match-list>  
        
    </core-toolbar>
    <v-app-bar-nav-icon @click.stop="toggleMenu()" v-if="!menu" class="main-menu-icon"></v-app-bar-nav-icon>
    
    
    
    
         <v-navigation-drawer v-if="authenticated && (!Role('_supplier,lead') || Role('_admin'))"
        v-model="showMenu"
        app
        clipped
        width="400"
     darks
     floating
      color="#fafafa"
      class="mt-5"
      > 
    <v-hover v-slot:default="{ hover }">
      <v-toolbar dense flat color="transparent">
          <v-toolbar-title class="pl-4 blue--text text--darken-1 subtitle-1">Uw vragenlijst</v-toolbar-title>
          <v-spacer></v-spacer>
      
      <v-btn v-if="hover && preview" icon @click="togglePreview();setMenu(false)">
                             <v-icon color="primary" v-if="preview">edit</v-icon>
                             <v-icon color="primary" v-else="">remove_red_eye</v-icon>
                             </v-btn>
      <v-btn icon  @click="showMenu=false" v-if="hover"><v-icon >close</v-icon></v-btn>
       </v-toolbar>
      </v-hover> 
      <questionaire-list ref="qlist" :max="max" :loading="loading" :disabled="selected.disabled" :isMain="isMain" @save="save" @addAll="addAll">
          <!--v-subheader class="primary--text pl-0">Uw vragenlijst</v-subheader-->
          
                 
                  <v-divider class="ml-4 mb-2"></v-divider>
                  
                    <questionaire-templates ref="templates" app="true" :all="all" @addall="save" @add="save" @setAll="(a) => all = a" :group="searchText!=''"></questionaire-templates>
          
      </questionaire-list>  
      </v-navigation-drawer>
      
    <v-content>
    <questionaire-item :isMain="isMain" v-if="!Role('admin,reseller') || !isMain" :index="index" :impersonate="impersonate" @save="save" @answer="answerThis" @addall="addAll">
          
          </questionaire-item>
    </v-content>
     <v-snackbar
          v-model="snackbar"
          :bottom="true"
          color="success"
          :multi-line="true"
          :timeout="2000"
        >
          {{ snackbar_message }}
          <v-btn
            dark
            text
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>   
  </v-app>
  </template>
<script>

import {
  mapActions,
  mapMutations,
  mapGetters,
  mapState
} from 'vuex'

 export default {
    props: [],
    data () {
      return {
          max: 6,
       loading: true,
       drawer: null,
      drawerRight: null,
      right: false,
      left: false,
       all: false
      }
    },
    computed: {
        ...mapState('app', ["preview", "deeplink"]),
    ...mapGetters('auth', ["Role",'relation','maincontact','role']),
      ...mapState('auth', ['authenticated',"settings"]),
      ...mapState('app', ["edit","footer","message","menu","preview"]),
      ...mapState('match', ["selected","suppliers"]),
      ...mapGetters('match', ["modified",'question','matchCount','search']),
       showMenu: {
          get() {
            return this.menu && !this.isMain
          },
          set(value) {
            this.setMenu(value)
          }
        },
        answerProto (){
            return { 
                    owner: {_id: this.relation._id, email: this.maincontact.email, name: this.maincontact.name, avatar: this.maincontact.avatar, organisation: this.relation.name, role: this.role}, 
                    date: new Date()
                }    
        },
      source () {
        return this.$router.currentRoute.params.source
      },
      index () {
        return this.$router.currentRoute.params.index
      },
      impersonate () {
        if (!this.$router.currentRoute.params.impersonate || this.$router.currentRoute.params.impersonate == '') return null
        return this.$router.currentRoute.params.impersonate
      },
      showUser () {
        if (this.impersonate == this.settings._id) return false
        if (this.impersonate) return true
        return false
      },
      searchText: {
            get() {
                 return this.search
            },
            set(value) {
                this.setSearch(value)
            }
      },
      company () {
        
        return {disabled: true,
                _supplier: {
                      name: "Uw vragenlijst", 
                      logo: this.settings.relation.logo,
                      contacts: this.settings.contacts
                      }, 
                  description: this.isEmpty ? this.$config.help.intro_question_laed_empty : this.$config.help.intro_question_laed,
                  questions: this.settings.questions,
                  answers: this.settings.answers || [],
                  tags: this.settings.tags
        }
      },
     snackbar_message: {// getter
            get: function () {
              return this.message
            },
            // setter
            set: function (message) {
              this.setMessage(message)
            }
        },
     snackbar: {// getter
            get: function () {
              if (this.message!='') return true
              return false
            },
            // setter
            set: function (questions) {
              this.setMessage('')
            }
        },
      isMain () {
        if (this.selected._id && this.selected._id != this.settings._id && !this.readonly) return false
        return true
      },
      isEmpty () {
         if (!this.selected || !this.selected.questions) return false
         return this.selected.questions.length==0
      },
      sourcesssss() {
        if (this.type == 'track' && this.impersonate) return "tracks"
        if (this.Role('supplier')) return 'supplier_matches'
        if (this.type == 'track' || this.type == 'lead') return "tracks"
        return null
        }
    },
     mounted () {
        if (this.authenticated) this.init()
      },
     watch: {
         impersonate (value,old){
             this.resetRelation()
         },
          $route (to, from){
            if (to.params.impersonate) {
                this.selectImporsonate(to.params.impersonate)
            } else {
                this.resetRelation()
                 return this.load({_id: this.index})
            }
        },
        authenticated(to,from) {
          if (!from && to) this.init()  
        }
     /* modified (value,old) {
          console.log('Questionaire modified watch', old, '=>', value)
         if (!old && value) return this.save()
      }*/
    },
     methods : {
       ...mapMutations('app', ["setEdit","setTemplate", "setMenu","toggleMenu", "setChat", "setMessage","togglePreview","setPreview"]),
       ...mapMutations('match', ["setSelected", "saveSelected", "updateSelected","setQuestion","setSearch","setSuppliers"]),
       ...mapActions('match', ['getItem', 'saveItem',"addAnswer","getList"]),
        ...mapActions('relation', ['updateRelation','getRelation']),
        ...mapActions('auth', ['logout','login','setRelation','resetRelation','addToRelation']),
      
      init() {
         var self = this
         
        if (this.impersonate){
           this.selectImporsonate(this.impersonate)
        }else if (this.index) {
            return this.load({_id: this.index})
        }
        if (!this.settings.questions) this.settings.questions = []
        
      },
      selectImporsonate(index){
          var self = this 
          this.getRelation({item: {_id:index}, next: function(item){
                self.setRelation(item)
                self.load({_id: this.index}, "track", index)
            }})
          
      },
      selectMatch(item){
          console.log(item)
         this.setSelected(item)
         this.checkQuestions()  
      },
      checkQuestions(){
          var self=this
        if (!this.Role("lead")) return false  
        this.selected.questions.forEach(function(question){
            if (self.selected.answers.filter(a=>a.question == question.title).length==0) self.answerThis(question)
         })
      },
      load (item,source,impersonate) {
          var self = this
            impersonate = impersonate || this.impersonate
          item.modified = false
          if (!source) source = this.source
          item._id = this.index
          var options = {source: source, type: this.source, index: item._id, item: item, next: function(item2){
              item = Object.assign(item , item2)
              //if (item || item._supplier) return false
              if (!item.questions) item.questions = []
              if (!item.answers) item.answers = []
              if (!self.isMain && item.questions.length == 0 && self.Role("lead")) item.questions = self.settings.questions

              if (!self.impersonate) {
                if (!item.description) item.description = self.settings.relation.description
                if ((!item.questions || item.questions.length == 0) && self.settings.questions && self.settings.questions.length > 0) {
                    item.questions =  self.settings.questions.slice(0)
                }
              }
              item.questions = item.questions.map(function(q){
                if (!q.checks) q.checks = []; 
                return q })
               if (item._match){
                   if(!item._match.description_nkc) item._match.description_nkc = self.relation.nkc_note
                   if(!item._match.description) item._match.description = self.relation.intro || self.relation.description
               }
                
                
               if (self.relation.answers && item.answers.filter(q => q.owner.organisation==self.relation.name).length ==0){
                   console.log('add suppliers answers')
                      item.questions.forEach(function(question){
                       
                       var a = self.relation.answers.filter(q => q.question == question.title)
                       if (a && a.length > 0) self.addAnswer(a[0])
                   })
               }
              if (self.Role('lead')) item.tags = self.settings.tags
              self.setSelected(item)
               self.checkQuestions()
              if (!impersonate && item._lead) self.loadMatches(item._lead._id)
              //document.title = "NKC - Vragenlijst: " + item._supplier.name;
              
            self.$emit('select', item)
          }}
          options.supplier = impersonate
          this.getItem(options)
          
      },
      /* load (settings){
         if (!settings.questions || settings.questions.length == 0) settings.questions =  this.settings.questions.slice(0)
          settings.questions = settings.questions.map(function(q){q.checks = q.checks|| []; return q })
         this.setSelected(settings)
         document.title = "NKC - Vragenlijst: " + settings._supplier.name;
         this.setChat(true)
         
       },*/
       loadMatches (lead_id) {
              var self = this
              //if (self.suppliers && self.suppliers.length > 0) return false
              self.loading =  true
              setTimeout(() => { self.loading = false}, 3000)
              //self.loading = (this.list.length == 0)
              this.cols = 3
              var options = {item: {}, index: lead_id,rating: ['delivered', 'definitive'], page_size: 10, source: 'match', next: function(response){
                  self.loading = false
                  self.setSuppliers(response)
                }}
               // console.log('LOAD MATCHES', options)
              this.getList(options)
            },
       save () {
           this.checkQuestions()
           this.saveSelected(false)
           this.selected.questions = this.selected.questions.sort(compare)
           this.isMain ? this.saveSettings() : this.saveTrack()
           this.saveRelation()
       },
        answerThis (question) {
            
             if (!question) return false
             
         this.setQuestion(question)
          var answer = { 
                    owner: {_id: this.relation._id, email: this.maincontact.email, name: this.maincontact.name, avatar: this.maincontact.avatar, organisation: this.relation.name, role: this.role}, 
                    date: new Date()
                } //Object.assign({}, this.answerProto)
          answer._id = this.selected._id
          answer.question = question.title
          answer.supplier = question.title_supplier
          answer.weight = question.weight
          answer.text = question.comment
          answer.type = question.type
          answer.options = question.checks
          answer.answer = question.answer || question.title
          //if (this.Role('lead')){
             if (!question.checks) question.checks = []
              if (question.type == 'radio' && question.checks[0] == question.options[0] ) {
                answer.tag = question.tag
                answer.answer = question.answer || question.answer || question.title
              }
              if (question.type == 'radio' && question.checks[0] == question.options[1]) {
                answer.tag = question.notag
                answer.answer = question.no_answer || question.answer || question.title
              }
          //}
          //this.answer.owner = {email: this.settings._user.email, name: this.settings._user.name}
          answer.score = question.score || 3
          
          this.addAnswer(answer)

            question.comment = null
            question.checks = []
            return question
        },
       addAll() {
         
         this.$refs.templates.addAll() 
       },
       saveSettings() {
        var self = this
        //this.settings.questions = this.questions
        //this.settings.answers = this.answers
        
        this.updateRelation({item: {_id: this.settings._id, questions: this.selected.questions, answers: this.selected.answers}, next: function(){
              self.loading = false
              self.snackbar_message = 'Instellingen zijn opgeslagen.'          
          }})
      },
      saveRelation() {
          if (!this.impersonate) return false
          var self = this, item = {answers: this.selected.answers.filter(q => q.owner._id==this.relation._id)}
          if (item.answers.length == 0) return false
          if (this.selected._match && this.selected._match.description && this.selected._match.description.length > 10) item.intro = this.selected._match.description
          if (this.selected._match && this.selected._match.description_nkc && this.selected._match.description_nkc.length > 10)item.nkc_note = this.selected._match.description_nkc
        
        this.addToRelation(item)
        item._id = this.impersonate
        this.updateRelation({item: item, next: function(){
              self.loading = false
              self.snackbar_message = 'Leveranciersgegevens zijn opgeslagen.'          
          }})
      },
      saveMatch(){
         var self = this
         var item = this.selected._match
        if (!item) return false
        this.saveItem({item: item, next: function(){
            self.loading = false
            self.snackbar_message = 'MatchINfo is opgeslagen.'
          }})
      },
      saveTrack () {
        var self = this
         var item = {_id: this.selected._id, 
                        questions: this.selected.questions, 
                        answers: this.selected.answers, 
                        score: this.selected.score, 
                        description: this.selected.description
                }
        this.saveItem({item: item, next: function(){
            self.saveMatch()
            self.loading = false
            self.snackbar_message = 'Vragenlijst is opgeslagen.'
          }})
      },
      home(){
          //if (this.source && this.index) return this.$router.push('/' + this.source + '/' +  this.index)
          //if (!this.deeplink) this.$router.push('/')
      }
    },
     sockets: {
        online (user) {
          this.message = user.name + ' is online'
        },
        relation_update (upd){
            this.settings.questions = upd.questions
            this.updateSelected(upd)
            if (upd._user) self.snackbar_message  = upd._user.name + ' heeft de algemene vragenlijst aangepast'
        }
      }
  }
  
  function compare( a, b ) {
      var scoreA = a.optional ? 0 : 1 , 
            scoreB = b.optional ? 0 : 1
      if ( scoreA < scoreB ){
        return 1;
      }
      if ( scoreA > scoreB ){
        return -1;
      }
      return 0;
    }
</script>
<style>
    .edit-button{
        float:right;
        margin-right:10px;
        z-index:10;
    }
    .main-menu-icon {
        position:fixed;
        margin-top:120px;
        z-index: 10;
        
    }
</style>